// import React, { useEffect, useRef } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { toast } from "react-toastify";
// import { clearIREvent } from "../../Redux/service/IR/IRWebSocket";
// import "./liveIR.css";

// export default function LiveIR() {
// 	const dispatch = useDispatch();
// 	const { latestIREvent, eventType } = useSelector((state) => state.irWebSocket);
// 	const userInfo = useSelector((state) => state.users.user); // Get logged user info
// 	const processedEventsRef = useRef(new Set());
	
// 	useEffect(() => {
// 		if (latestIREvent && eventType) {
// 			// Get user role from attributes - safely handle if userInfo is not available
// 			const userRole = userInfo?.attributes?.role?.toLowerCase();
			
// 			// Filter out resubmitted and rejected events for consultants
// // Filter out only QA rejection events for consultants
// if (userRole === 'consultant') {
//     if (eventType === 'qa_reviewed' && latestIREvent.result === 'REJECTED') {
//         dispatch(clearIREvent());
//         return;
//     }
// }
			
// 			const eventIdentifier = `${latestIREvent.id}-${eventType}-${latestIREvent.ir_number}`;

			
// 			if (processedEventsRef.current.has(eventIdentifier)) {
// 				return;
// 			}
			
// 			processedEventsRef.current.add(eventIdentifier);
			
// 			if (processedEventsRef.current.size > 50) {
// 				const arr = Array.from(processedEventsRef.current);
// 				processedEventsRef.current = new Set(arr.slice(-50));
// 			}
			
// 			const lang = localStorage.getItem("lang");
// 			const rtl = lang === "ar";
			
// 			const eventConfig = {
// 				created: {
// 					title: { en: "New Inspection Request", ar: "طلب تفتيش جديد" },
// 					type: "success"
// 				},
// 				updated: {
// 					title: { en: "Inspection Request Updated", ar: "تم تحديث طلب التفتيش" },
// 					type: "info"
// 				},
// 				resubmitted: {
// 					title: { en: "IR Resubmitted", ar: "تم إعادة تقديم الطلب" },
// 					type: "success"
// 				},
// 				qa_reviewed: {
// 					title: {
// 						en: latestIREvent.result === 'APPROVED' ? "QA Approved" : "QA Rejected",
// 						ar: latestIREvent.result === 'APPROVED' ? "موافقة مراقب الجودة" : "رفض مراقب الجودة"
// 					},
// 					type: latestIREvent.result === 'APPROVED' ? "success" : "error"
// 				},
// 				consultant_reviewed: {
// 					title: {
// 						en: latestIREvent.result === 'APPROVED' 
// 							? "Consultant Approved"
// 							: latestIREvent.result === 'APPROVED_WITH_COMMENTS'
// 							? "Approved with Comments"
// 							: "Consultant Rejected",
// 						ar: latestIREvent.result === 'APPROVED'
// 							? "موافقة الاستشاري"
// 							: latestIREvent.result === 'APPROVED_WITH_COMMENTS'
// 							? "الموافقة مع ملاحظات"
// 							: "رفض الاستشاري"
// 					},
// 					type: latestIREvent.result === 'REJECTED' ? "error" : "success"
// 				}
// 			};

// 			const config = eventConfig[eventType];
			
// 			if (config) {
// 				// Close button INSIDE the toast content
// 				const toastId = eventIdentifier;
				
// 				const CustomToast = () => (
// 					<div className={`ir-toast-container ${rtl ? 'rtl' : 'ltr'}`}>
// 						{/* Close button inside content */}
// <button
// 	className="ir-custom-close-btn"
// 	onClick={(e) => {
// 		e.stopPropagation();
// 		e.preventDefault();
// 		console.log("Closing toast:", toastId);
		
// 		// Try all methods
// 		toast.dismiss(toastId);
// 		toast.dismiss();
		
// 		// Fallback: manually remove from DOM
// 		const toastElement = e.target.closest('.Toastify__toast');
// 		if (toastElement) {
// 			toastElement.style.animation = 'none';
// 			toastElement.style.opacity = '0';
// 			toastElement.style.transform = 'translateX(100%)';
// 			setTimeout(() => {
// 				toastElement.remove();
// 			}, 300);
// 		}
// 	}}
// 	aria-label="Close"
// 	type="button"
// >
// 	✕
// </button>
						
// 						<div className="ir-toast-content">
// 							<div className="ir-toast-header">
// 								<span className="ir-toast-title">
// 									{config.title[rtl ? 'ar' : 'en']} - {latestIREvent.ir_number}
// 								</span>
// 							</div>

// 							{latestIREvent.project?.name && (
// 								<div className="ir-toast-project">
// 									<span className="ir-toast-project-icon">📍</span>
// 									<span className="ir-toast-project-label">
// 										{rtl ? 'المشروع:' : 'Project:'}
// 									</span>
// 									<span className="ir-toast-project-name">
// 										{latestIREvent.project.name}
// 									</span>
// 								</div>
// 							)}

// 							{latestIREvent.submittedBy && (
// 								<div className="ir-toast-footer">
// 									<span className="ir-toast-submitted-label">
// 										{rtl ? 'تم التقديم بواسطة:' : 'Submitted by:'}
// 									</span>
// 									<span className="ir-toast-submitted-by">
// 										{latestIREvent.submittedBy.name || 'Contractor'}
// 									</span>
// 								</div>
// 							)}
// 						</div>
// 					</div>
// 				);

// 				toast[config.type](<CustomToast />, {
// 					toastId: toastId,
// 					rtl,
// 					autoClose: 7000,
// 					position: "top-right",
// 					closeButton: false, // Disable default close button
// 					pauseOnHover: true,
// 					draggable: true,
// 					hideProgressBar: false,
// 					className: 'ir-toast-custom',
// 					bodyClassName: 'ir-toast-body',
// 					progressClassName: 'ir-toast-progress',
// 					closeOnClick: false,
// 				});
// 			}
			
// 			dispatch(clearIREvent());
// 		}
// 	}, [latestIREvent, eventType, dispatch, userInfo]);
	
// 	return null;
// }

import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { clearIREvent } from "../../Redux/service/IR/IRWebSocket";
import "./liveIR.css";

export default function LiveIR() {
	const dispatch = useDispatch();
	const { latestIREvent, eventType } = useSelector((state) => state.irWebSocket);
	const userInfo = useSelector((state) => state.users.user);
	const processedEventsRef = useRef(new Set());
	
	useEffect(() => {
		if (latestIREvent && eventType) {
			const userRole = userInfo?.attributes?.role?.toLowerCase();
			const userId = userInfo?.id;
			
			console.log('🔔 LiveIR received event:', {
				eventType,
				irId: latestIREvent.id,
				ir_number: latestIREvent.ir_number,
				result: latestIREvent.result,
				status: latestIREvent.status,
				userRole,
				userId
			});
			
			// ✅ IMPROVED FILTERING LOGIC
			// Only filter out events that shouldn't be shown to this role
			if (userRole === 'consultant') {
				// Consultant should NOT see QA rejections (contractor's business)
				if (eventType === 'qa_reviewed' && latestIREvent.result === 'REJECTED') {
					console.log('❌ Filtered out: QA rejection (not relevant for consultant)');
					dispatch(clearIREvent());
					return;
				}
				
				// Consultant should NOT see contractor resubmissions to QA
				if (eventType === 'resubmitted' && latestIREvent.status === 'PENDING_QA') {
					console.log('❌ Filtered out: Contractor resubmission to QA (not relevant for consultant)');
					dispatch(clearIREvent());
					return;
				}
			}
			
			// if (userRole === 'contractor') {
			// 	// Contractor should NOT see consultant rejections to QA
			// 	if (eventType === 'consultant_reviewed' && latestIREvent.result === 'REJECTED') {
			// 		console.log('❌ Filtered out: Consultant rejection to QA (not relevant for contractor)');
			// 		dispatch(clearIREvent());
			// 		return;
			// 	}
			// }
			
			// ✅ IMPROVED EVENT IDENTIFIER - Include result to differentiate same IR with different outcomes
			const eventIdentifier = `${latestIREvent.id}-${eventType}-${latestIREvent.result || 'none'}-${Date.now()}`;
			
			if (processedEventsRef.current.has(eventIdentifier)) {
				console.log('⏭️ Skipped duplicate event:', eventIdentifier);
				return;
			}
			
			processedEventsRef.current.add(eventIdentifier);
			
			// Keep only last 50 events to prevent memory leak
			if (processedEventsRef.current.size > 50) {
				const arr = Array.from(processedEventsRef.current);
				processedEventsRef.current = new Set(arr.slice(-50));
			}
			
			const lang = localStorage.getItem("lang");
			const rtl = lang === "ar";
			
			const eventConfig = {
				created: {
					title: { en: "New Inspection Request", ar: "طلب تفتيش جديد" },
					type: "success"
				},
				updated: {
					title: { en: "Inspection Request Updated", ar: "تم تحديث طلب التفتيش" },
					type: "info"
				},
				resubmitted: {
					title: { en: "IR Resubmitted", ar: "تم إعادة تقديم الطلب" },
					type: "success"
				},
				qa_reviewed: {
					title: {
						en: latestIREvent.result === 'APPROVED' ? "QA Approved" : "QA Rejected",
						ar: latestIREvent.result === 'APPROVED' ? "موافقة مراقب الجودة" : "رفض مراقب الجودة"
					},
					type: latestIREvent.result === 'APPROVED' ? "success" : "error"
				},
				consultant_reviewed: {
					title: {
						en: latestIREvent.result === 'APPROVED' 
							? "Consultant Approved"
							: latestIREvent.result === 'APPROVED_WITH_COMMENTS'
							? "Approved with Comments"
							: "Consultant Rejected",
						ar: latestIREvent.result === 'APPROVED'
							? "موافقة الاستشاري"
							: latestIREvent.result === 'APPROVED_WITH_COMMENTS'
							? "الموافقة مع ملاحظات"
							: "رفض الاستشاري"
					},
					type: latestIREvent.result === 'REJECTED' ? "error" : "success"
				}
			};

			const config = eventConfig[eventType];
			
			if (config) {
				const toastId = eventIdentifier;
				
				console.log('✅ Showing toast:', {
					toastId,
					title: config.title[rtl ? 'ar' : 'en'],
					type: config.type
				});
				
				const CustomToast = () => (
					<div className={`ir-toast-container ${rtl ? 'rtl' : 'ltr'}`}>
						<button
							className="ir-custom-close-btn"
							onClick={(e) => {
								e.stopPropagation();
								e.preventDefault();
								console.log("Closing toast:", toastId);
								
								toast.dismiss(toastId);
								toast.dismiss();
								
								const toastElement = e.target.closest('.Toastify__toast');
								if (toastElement) {
									toastElement.style.animation = 'none';
									toastElement.style.opacity = '0';
									toastElement.style.transform = 'translateX(100%)';
									setTimeout(() => {
										toastElement.remove();
									}, 300);
								}
							}}
							aria-label="Close"
							type="button"
						>
							✕
						</button>
						
						<div className="ir-toast-content">
							<div className="ir-toast-header">
								<span className="ir-toast-title">
									{config.title[rtl ? 'ar' : 'en']} - {latestIREvent.ir_number}
								</span>
							</div>

							{latestIREvent.project?.name && (
								<div className="ir-toast-project">
									<span className="ir-toast-project-icon">📍</span>
									<span className="ir-toast-project-label">
										{rtl ? 'المشروع:' : 'Project:'}
									</span>
									<span className="ir-toast-project-name">
										{latestIREvent.project.name}
									</span>
								</div>
							)}

							{latestIREvent.submittedBy && (
								<div className="ir-toast-footer">
									<span className="ir-toast-submitted-label">
										{rtl ? 'تم التقديم بواسطة:' : 'Submitted by:'}
									</span>
									<span className="ir-toast-submitted-by">
										{latestIREvent.submittedBy.name || 'Contractor'}
									</span>
								</div>
							)}
						</div>
					</div>
				);

				toast[config.type](<CustomToast />, {
					toastId: toastId,
					rtl,
					autoClose: 7000,
					position: "top-right",
					closeButton: false,
					pauseOnHover: true,
					draggable: true,
					hideProgressBar: false,
					className: 'ir-toast-custom',
					bodyClassName: 'ir-toast-body',
					progressClassName: 'ir-toast-progress',
					closeOnClick: false,
				});
			} else {
				console.warn('⚠️ Unknown event type:', eventType);
			}
			
			dispatch(clearIREvent());
		}
	}, [latestIREvent, eventType, dispatch, userInfo]);
	
	return null;
}